(function () {
  'use strict';

  angular
    .module('trainingPrograms')
    .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('trainingPrograms', {
            sticky: true,
            url: '/training-programs',
            views: {
                'trainingProgramsView': {
                    templateUrl: 'training-programs/views/training-programs.tpl.html',
                    controller: 'TrainingProgramsCtrl',
                    controllerAs: 'trainingPrograms'
                }
            },
            onEnter: function (UserPrivilegesService) {
               
            }

        });
  }
}());
